import { occupiesTeam } from './next-free-time.js';
/**
 * Ce que le créneau **recouvre** dans la journée de l'équipe (#431, #669) : le premier rendez-vous ou
 * point interne dont la plage chevauche la sienne, durée comprise — 14 h sous un rendez-vous de
 * 13 h à 16 h est déjà pris. Une plage qui commence quand l'autre finit ne la recouvre pas.
 *
 * Les mêmes créneaux que `nextFreeTime` : un contrôle effectué garde le sien, une demande abandonnée
 * le rend. `except` écarte ce qu'on déplace — la demande d'un rendez-vous, ou le point interne
 * lui-même : on ne se recouvre pas soi-même.
 *
 * ⚠️ **Une alerte, jamais un refus** (M21) : l'appelant nomme ce qu'il trouve et laisse enregistrer.
 */
export function slotTaken(occupied, teamId, scheduledAt, durationMinutes, except) {
    const start = Date.parse(scheduledAt);
    const end = start + durationMinutes * 60_000;
    return (occupied.find((slot) => {
        const from = Date.parse(slot.scheduledAt);
        const to = from + slot.durationMinutes * 60_000;
        const self = slot.inquiry?.id ?? slot.id;
        return (occupiesTeam(slot, teamId) &&
            (except === undefined || self !== except) &&
            from < end &&
            to > start);
    }) ?? null);
}
//# sourceMappingURL=slot-taken.js.map